export const DEFAULT_ERROR_CODE = 'GENERAL_ERROR';
export const DEFAULT_ERROR_MESSAGE = 'Request error';
/**
 * Method: getErrorCode
 * Description: used for retrieving the error code from errors for use in error handling
 * Accepts: JSON
 * Returns: String
 */
export function getErrorCode(error?: Record<string, any>): string {
  error = error || {};

  const errorCode =
    error.code ||
    error.errorCode ||
    error.response?.data?.code ||
    error.response?.data?.errorCode ||
    error.message;

  return errorCode
    ? errorCode
        .toString()
        .split(' ')
        .join('_')
        .toUpperCase()
    : DEFAULT_ERROR_CODE;
}

/**
 * Method: getErrorMessage
 * Description: used for retrieving the error message from errors for use in error handling.
 */
export function getErrorMessage(error?: Record<string, any> | string): string {
  error = error || {};

  let errorMessage = DEFAULT_ERROR_MESSAGE;
  if (typeof error === 'string') {
    errorMessage = error;
  } else if (error.response?.data?.errors?.length) {
    const firstError = error.response.data.errors[0];
    if (firstError.errors?.length) {
      [errorMessage] = firstError.errors;
    } else {
      errorMessage = firstError.message || firstError;
    }
  } else if (error.response?.data?.errorDescription) {
    errorMessage = error.response.data.errorDescription;
  } else if (error.response?.data?.error) {
    errorMessage = error.response.data.error.message || error.response.data.error;
  } else if (error.response?.data?.message) {
    errorMessage = error.response.data.message;
  } else if (error.message?.message) {
    errorMessage = error.message.message;
  } else if (error.message) {
    errorMessage = error.message;
  }
  return errorMessage;
}
